import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { NgModel } from '@angular/forms';
import { HumanResourceService } from '../../services/human-resource.service';
import * as moment from 'moment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-client-conveyance-summary',
  templateUrl: './client-conveyance-summary.component.html',
  styleUrls: ['./client-conveyance-summary.component.css'],
})
export class ClientConveyanceSummaryComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  selectedBranch;
  isBranchSelected = false;
  branchList;
  selectedClientStatus;
  selectBillingDate;
  billingDateList;
  selectClientName;
  clientNameList;
  clientConveyanceList;
  showClientConveyanceDetails = true;
  allBillingAmountTotal;
  clientBilledConveyanceList;
  totalTwoWheelerCount;
  totalFourWheelerCount;
  totalBusAutoCount;
  totalBilledConveyanceCount;
  clientMonthlyConveyanceList;
  totalMonthlyConveyanceCount;
  showBilledConveyanceDetails = false;
  showMonthlyConveyanceDetails = false;
  showConveyanceTableDetails = false;
  userRole;
  accessResponse: any;

  constructor(
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedClientStatus = '';
    this.selectBillingDate = '';
    this.selectClientName = '';
    this.selectedBranch = '';
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onYearSelected() {
    this.selectedBranch = '';
    this.showConveyanceTableDetails = false;
    if (this.selectedFinancialYear != '' &&
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined) {
      // this.masterDataService.getBranch().subscribe((res) => {
      //   this.branchList = res;
      // });
      this.masterDataService.getBranch().subscribe((res) => {
        const branches = res as any[];
        const userBranchId = Number(localStorage.getItem('branchId'));

        this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
      });
    }
  }

  onSelectBranch() {
    this.selectClientName = '';
    this.clientNameList = [];
    this.selectedClientStatus = '';
    // console.log('branch id', this.selectedBranch);
    // if (
    //   this.selectedFinancialYear != '' &&
    //   this.selectedFinancialYear != null &&
    //   this.selectedFinancialYear != undefined &&
    //   this.selectedBranch != '' &&
    //   this.selectedBranch != null &&
    //   this.selectedBranch != undefined
    // ) {
    //   this.humanResourceService
    //     .getClientsByBranch(this.selectedBranch)
    //     .subscribe((res: any) => {
    //       if (res.length > 0) {
    //         this.clientNameList = res;
    //       } else {
    //          this.commonMessageService.swalAlertWithoutIcon('','Client not present for this selectedBranch');
    //       }
    //     });
    // }
  }

  onStatusSelect() {
    this.selectClientName = '';
    console.log('branch id', this.selectedBranch);
    if (
      this.selectedFinancialYear != '' &&
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedBranch != '' &&
      this.selectedBranch != null &&
      this.selectedBranch != undefined
    ) {
      console.log('this.branch', this.selectedBranch, this.selectedClientStatus);
      this.masterDataService.getClientListByBranchStatus(this.selectedBranch, this.selectedClientStatus).subscribe((resp: any) => {
        console.log('response details client list', resp);
        if (resp.length > 0) {
          this.clientNameList = resp;
        } else {
          //  this.commonMessageService.swalAlertWithoutIcon('','Client not present for this selectedBranch');
        }
      });
    }
  }

  onSelectClientName() {
    this.selectBillingDate = '';
    if (
      this.selectClientName != '' &&
      this.selectClientName != null &&
      this.selectClientName != undefined
    ) {
      this.humanResourceService
        .getClientBillingDate(
          this.selectClientName,
          this.selectedFinancialYear.id
        )
        .subscribe((res: any) => {
          console.log('billing date list', res);
          this.billingDateList = res;
        });
    }
  }

  getRowSpanForClient(client) {
    var count = 1;
    client.diaryClosingDates.map((res) => {
      res.periods.map((res1) => {
        count++;
      });
    });
    return count;
  }

  calculateBillingAmount(diaryClosingDateList) {
    var billingAmount = 0;
    diaryClosingDateList.map((res) => {
      res.periods.map((res1) => {
        billingAmount += res1.amount;
      });
    });
    return billingAmount;
  }

  changeMonthNumberToName(month) {
    return moment(month, 'M').format('MMM');
  }

  showExportToExcelButton = false;
  onViewReport() {
    // this.showConveyanceTableDetails = false;

    if (
      this.selectedFinancialYear == '' ||
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectBillingDate == '' ||
      this.selectBillingDate == null ||
      this.selectBillingDate == undefined ||
      this.selectClientName == '' ||
      this.selectClientName == null ||
      this.selectClientName == undefined ||
      this.selectedBranch == '' ||
      this.selectedBranch == null ||
      this.selectedBranch == undefined
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    this.humanResourceService
      .getClientConveyanceReport(
        this.selectClientName,
        this.selectBillingDate.id,
        this.selectedFinancialYear.id
      )
      .subscribe((res) => {
        console.log('client Conveyance Report List', res);
        if (res != null) {
          this.clientConveyanceList = [];
          this.clientConveyanceList.push(res);

          console.log('client Conveyance Report List', this.clientConveyanceList);
          if (this.clientConveyanceList.length == 0) {
            this.commonMessageService.swalAlertWithoutIcon('', 'No record Found.');
            this.showExportToExcelButton = false;
          } else {
            this.showConveyanceTableDetails = true;
            this.showExportToExcelButton = true;
            console.log('client Conveyance Report List', this.showConveyanceTableDetails);
            this.AllBillingAmountTotal();
          }
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', 'No record Found.');
        }
        // this.clientConveyanceList=data;
      });
  }

  exportToExcelClientCoveyance() {
    this.humanResourceService
      .getClientConveyanceReportExportToExcel(
        this.selectClientName,
        this.selectBillingDate.id,
        this.selectedFinancialYear.id
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientConveyanceSummaryReport.xlsx";
        link.click();
      });
  }

  AllBillingAmountTotal() {
    var allBillingAmount = 0;
    this.clientConveyanceList.map((res) => {
      if (res.diaryClosingDates != null) {
        res.diaryClosingDates.map((res1) => {
          res1.periods.map((res2) => {
            allBillingAmount += res2.amount;
          });
        });
      }
      allBillingAmount += res.tsheetAllowance
    });
    console.log('all allBillingAmount', allBillingAmount);
    this.allBillingAmountTotal = Math.round(allBillingAmount);
    console.log('all billing amount', this.allBillingAmountTotal);
  }

  goBack() {
    this.showClientConveyanceDetails = true;
    this.showMonthlyConveyanceDetails = false;
    this.showBilledConveyanceDetails = false;
    this.showConveyanceTableDetails = true;
  }

  //Client Billed conveyance Details
  billedClientId;
  billedBillingDateId;
  showBilledExportToExcelButton = false;
  getClientBilledConveyanceList(clientId, billingDateId) {
    this.billedClientId = clientId;
    this.billedBillingDateId = billingDateId;
    this.humanResourceService
      .getClientByBilledConveyanceReport(clientId, billingDateId)
      .subscribe((res: any) => {
        this.clientBilledConveyanceList = res;
        console.log('Client name list', this.clientBilledConveyanceList);
        if (this.clientBilledConveyanceList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found in Billed conveyance Report');
          this.showBilledExportToExcelButton = false;
          return;
        }
        this.showClientConveyanceDetails = false;
        this.showConveyanceTableDetails = false;
        this.showBilledConveyanceDetails = true;
        this.showBilledExportToExcelButton = true;
        this.calculateTotalBilledConveyanceDetails();
      });
  }

  exportToExcelClientBilledConveyance() {
    this.humanResourceService
      .getClientByBilledConveyanceExportToExcelReport(this.billedClientId, this.billedBillingDateId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "BilledClientConveyanceSummaryReport.xlsx";
        link.click();
      });
  }

  getRowSpanForDiaryDate(diaryDate) {
    var count = 0;
    diaryDate.diaryDetails.map((res) => {
      count++;
    });
    return count;
  }
  calculateTotalBilledConveyanceDetails() {
    this.totalTwoWheelerCount = 0;
    this.totalFourWheelerCount = 0;
    this.totalBusAutoCount = 0;
    this.totalBilledConveyanceCount = 0;
    var totalTwoWheeler = 0;
    var totalFourWheeler = 0;
    var totalBusAuto = 0;
    var totalBilledConveyance = 0;
    this.clientBilledConveyanceList.diaryDates.map((res) => {
      res.diaryDetails.map((res1) => {
        totalTwoWheeler += res1.twoWheeler;
        this.totalTwoWheelerCount = Math.round(totalTwoWheeler);
        totalFourWheeler += res1.fourWheeler;
        this.totalFourWheelerCount = Math.floor(totalFourWheeler);
        totalBusAuto += res1.busAuto;
        this.totalBusAutoCount = Math.round(totalBusAuto);
        totalBilledConveyance += res1.billedConveyance;
        this.totalBilledConveyanceCount = Math.round(totalBilledConveyance);
      });
    });
  }

  //Client Monthly conveyance Details
  monthlyClientId;
  monthlyClosingDateId;
  month;
  year;
  showMonthlyExportToExcelButton = false;
  getClientMonthlyConveyanceList(clientId, closingDateId, month, year) {
    this.monthlyClientId = clientId;
    this.monthlyClosingDateId = closingDateId;
    this.month = month;
    this.year = year;
    this.humanResourceService
      .getClientByMonthlyConveyanceReport(
        clientId,
        closingDateId,
        this.selectBillingDate.id,
        month,
        year
      )
      .subscribe((res) => {
        console.log('monthly convence report', res);
        this.clientMonthlyConveyanceList = res;
        if (this.clientMonthlyConveyanceList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found in Monthly conveyance Report');
          this.showMonthlyExportToExcelButton = false;
          return;
        }
        this.showClientConveyanceDetails = false;
        this.showConveyanceTableDetails = false;
        this.showMonthlyConveyanceDetails = true;
        this.showMonthlyExportToExcelButton = true;
        this.calculateTotalConveyanceDetails();
      });
  }

  exportToExcelClientMonthlyConveyanceList() {
    this.humanResourceService
      .getClientByMonthlyConveyanceExcelToExportReport(
        this.monthlyClientId,
        this.monthlyClosingDateId,
        this.selectBillingDate.id,
        this.month,
        this.year
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "MonthlyClientConveyanceSummaryReport.xlsx";
        link.click();
      });
  }

  calculateTotalConveyanceDetails() {
    this.totalMonthlyConveyanceCount = 0;
    var total = 0;
    if (this.clientMonthlyConveyanceList != null) {
      this.clientMonthlyConveyanceList.diaryDates.map((res) => {
        res.diaryDetails.map((res1) => {
          total += res1.totalConveyance;
          this.totalMonthlyConveyanceCount = Math.round(total);
        });
      });
    }
    console.log('total', total, 'all total', this.totalMonthlyConveyanceCount);
  }

  changeMonthToNumberMonthlyConveyance(month) {
    return moment(month, 'M').format('MMM');
  }

  exportAsPDFClientConveyanceSummary() {
    var body = [];
    var billDate;
    body.push([{ text: 'Client Name', style: 'headerStyle' }, { text: 'Diary Closing Date', style: 'headerStyle' }, { text: 'Period', style: 'headerStyle' }, { text: 'Billed Amount', style: 'headerStyle' }]);
    for (let i = 0; i < this.clientConveyanceList.length; i++) {
      var taskSize = 2;
      billDate = moment(this.clientConveyanceList[i].billingDate).format('DD-MMM-YYYY');
      for (let j = 0; j < this.clientConveyanceList[i].diaryClosingDates.length; j++) {
        taskSize = taskSize + this.clientConveyanceList[i].diaryClosingDates[j].periods.length;
      }
      var totalDays = 0;
      for (let j = 0; j < this.clientConveyanceList[i].diaryClosingDates.length; j++) {
        for (let k = 0; k < this.clientConveyanceList[i].diaryClosingDates[j].periods.length; k++) {
          var formatMonth = moment(this.clientConveyanceList[i].diaryClosingDates[j].periods[k].month, 'M').format('MMM');
          var row = [
            { text: this.clientConveyanceList[i].clientName, rowSpan: taskSize },
            { text: moment(this.clientConveyanceList[i].diaryClosingDates[j].diaryClosigDate).format('DD-MM-YYYY'), rowSpan: this.clientConveyanceList[i].diaryClosingDates[j].periods.length },
            { text: `${formatMonth} - ${this.clientConveyanceList[i].diaryClosingDates[j].periods[k].year}` },
            { text: this.clientConveyanceList[i].diaryClosingDates[j].periods[k].amount }
          ]
          body.push(row)
          totalDays = totalDays + this.clientConveyanceList[i].diaryClosingDates[j].periods[k].amount;
        }
      }
      var totalRow = []
      var diaryTotalRow = []
      diaryTotalRow = ['', { text: 'Diary Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(totalDays)}`, fillColor: '#e1f4f7' }]
      totalRow = ['', { text: 'Travel Total', fillColor: '#e1f4f7' }, { text: '', fillColor: '#e1f4f7' }, { text: `${Math.round(this.clientConveyanceList[i].tsheetAllowance)}`, fillColor: '#e1f4f7' }]
      body.push(diaryTotalRow, totalRow)
    }

    body.push([{ text: 'Total', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: '', style: 'alltotalStyle' }, { text: `${Math.round(this.allBillingAmountTotal)}`, style: 'alltotalStyle' }])

    console.log('rows array', body);
    let docDefinition = {
      info: { title: 'Client Conveyance Summary' },
      pageOrientation: 'landscape',
      content: [
        { text: 'P G BHAGWAT LLP, Chartered Accountants', style: 'header' },
        { text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', style: 'header1' },
        { text: 'Client Conveyance Summary', style: 'header2' },
        { text: `Bill Date:${billDate}`, style: 'header3' },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*'],
            body: body
          },
          // layout: 'noBorders'
        }
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
        },
        header1: {
          alignment: 'center',

        },
        header2: {
          fontSize: 14,
          bold: true,
          alignment: 'center',
          margin: [0, 10, 0, 5],
        },
        header3: {
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        headerStyle: {
          fillColor: '#17a2b8 !important',
          color: 'white',
          margin: [8, 8, 8, 8],
          fontSize: 14,
          bold: true,
        },
        alltotalStyle: {
          fillColor: '#e1f4f7',
          margin: [0, 5, 0, 5],
        },
      }
    }
    pdfMake.createPdf(docDefinition).download('ClientConveyanceReport.pdf');
  }
}


